<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="900" persistent fluid scrollable content-class="round-2xl")
  v-card(height="70dvh")
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Upcoming appointment
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.primary--text.pa-6
      appointment-section

</template>

<script>
import AppointmentSection from '@/components/clinic/consultation/AppointmentSection.vue'

export default {
  components: { AppointmentSection },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    }
  }
}
</script>
